<template>
    <school-container />
</template>
<script>
import SchoolContainer from "./containers/SchoolContainer";

export default {
    name: "School",
    components: {
        SchoolContainer
    }
};
</script>
